// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"73f84958","166":"562fecaa","265":"6a85ee8f","631":"a705aba8","828":"a705aba8"}[chunkId] + ".chunk.css";
};